// pipe: frontend wave (F6) — the minimal storefront nav layout (mirrors
// portal-layout.tsx). A token-styled header with links to the shop screens,
// the cart count, and the buyer session affordance, then an <Outlet/> for the
// screen body.
import { useI18n } from '@affine/i18n';
import { Link, Outlet } from 'react-router-dom';

import { useStorefrontAuth } from '../auth/storefront-auth-provider';
import { useCart } from '../services/cart-provider';
import * as styles from './storefront.css';

export function StorefrontLayout() {
  const t = useI18n();
  const { token, login, logout } = useStorefrontAuth();
  const { lines } = useCart();

  return (
    <div className={styles.layout}>
      <nav className={styles.nav}>
        <Link className={styles.navLink} to="/">
          {t['com.affine.storefront.nav.shop']()}
        </Link>
        <Link className={styles.navLink} to="/cart">
          {t['com.affine.storefront.nav.cart']({ count: String(lines.length) })}
        </Link>
        {token ? (
          <Link className={styles.navLink} to="/orders">
            {t['com.affine.storefront.nav.orders']()}
          </Link>
        ) : (
          <Link className={styles.navLink} to="/register">
            {t['com.affine.storefront.nav.register']()}
          </Link>
        )}
        <span className={styles.navSpacer} />
        {token ? (
          <button type="button" className={styles.navButton} onClick={logout}>
            {t['com.affine.storefront.nav.sign-out']()}
          </button>
        ) : (
          <button
            type="button"
            className={styles.navButton}
            onClick={() => void login()}
          >
            {t['com.affine.storefront.nav.sign-in']()}
          </button>
        )}
      </nav>
      <div className={styles.screen}>
        <Outlet />
      </div>
    </div>
  );
}
